import { useOutletContext } from "react-router-dom";
import type { ChapterDto } from "@mmm/contracts";
import type { SubjectWithChildren } from "../../../types.js";

export interface ChapterOutletContext {
  subject: SubjectWithChildren;
  chapter: ChapterDto;
}

export function useChapterContext(): ChapterOutletContext {
  return useOutletContext<ChapterOutletContext>();
}
